import {
  ProductBySlugAttribute,
  ProductBySlugDesignerAttribute,
} from "@/common/contracts/pdp.contracts";

export const isProductBySlugDesignerAttribute = (
  attribute?: ProductBySlugAttribute
): attribute is ProductBySlugDesignerAttribute => {
  return attribute?.__typename === "Designer";
};
